/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./cart.module.css";
import Button from "../../../component/button";
import { withTranslation } from "react-i18next";
import Input from "../../../component/inputpm";
import currencyFormatter from "../../../helper/currencyFormatter";
import { Link } from "react-router-dom";

// Line item start here
const LineItem = (props) => (
  <div className={classes.componentDiv}>
    <div className={classes.componentNameDiv}>
      {/* Check if item quantity is modifiable */}
      {props.quantityModifiable ? (
        <>
          {/* The component their quantity is modifiable will goes here */}
          <div style={{ width: "2.5rem", float: "left" }}>
            {/* Remove item from packaged solution */}
            <Button
              className={classes.removeButton}
              onClick={() => {
                props.removeComponent(props.compType, props.compIndex);
              }}
            >
              <span>x</span>
            </Button>
          </div>
          <span>
            <span>
              <Input
                className={classes.quantityInput}
                type="number"
                min="1"
                step="1"
                value={props.componentQuantity}
                onChange={(e) => {
                  props.changeComponentQuantity(e.target.value);
                }}
                style={{ backgroundColor: "#fff", borderRadius: "5px" }}
              />
            </span>
            <span>{` x ${props.name} `}</span>
            <span>
              {!props.price.recurringPrice && props.price.purchasePrice
                ? parseInt(props.price.purchasePrice) === 0 &&
                  props.dontShowZero
                  ? ""
                  : "(" +
                    props.componentQuantity +
                    " x " +
                    currencyFormatter(
                      (
                        Math.round(props.price.purchasePrice * 100) / 100
                      ).toFixed(2),
                    ) +
                    ")"
                : ""}
            </span>
            <span>
              {props.price.recurringPrice
                ? parseInt(props.price.recurringPrice.price) === 0 &&
                  props.dontShowZero
                  ? ""
                  : "(" +
                    props.componentQuantity +
                    " x " +
                    currencyFormatter(
                      (
                        Math.round(props.price.recurringPrice.price * 100) / 100
                      ).toFixed(2),
                    ) +
                    ")"
                : ""}
            </span>
          </span>
        </>
      ) : (
        // Non modifiable quantity component will goes here
        <span>
          {props.name ? props.name : props.internalName}&nbsp;
          {props.providerType === "SALES_CHNL_PROVIDER" ||
          props.publicBrowsing ? (
            props.price ? (
              <>
                {/* ({props.componentQuantity ? props.componentQuantity : props.quantity} x {props.price.recurringPrice ? '$' + (Math.round(props.price.recurringPrice.price * 100) / 100).toFixed(2) : '$' + (Math.round(props.price.purchasePrice * 100) / 100).toFixed(2)}) */}
                ({props.componentQuantity * props.quantity} x{" "}
                {props.price.recurringPrice
                  ? currencyFormatter(
                      (
                        Math.round(props.price.recurringPrice.price * 100) / 100
                      ).toFixed(2),
                    )
                  : currencyFormatter(
                      (
                        Math.round(props.price.purchasePrice * 100) / 100
                      ).toFixed(2),
                    )}
                )
              </>
            ) : (
              ""
            )
          ) : (
            <>({props.componentQuantity * props.quantity})</>
          )}
        </span>
      )}
    </div>
    <div className={classes.priceDiv}>
      {/* The component their quantity is modifiable will goes here */}
      {props.quantityModifiable ? (
        <React.Fragment>
          {/* The component their quantity is modifiable will goes here */}
          <span className={classes.priceSpan}>
            {!props.price.recurringPrice && props.price.purchasePrice
              ? parseInt(props.price.purchasePrice) === 0 && props.dontShowZero
                ? ""
                : currencyFormatter(
                    (
                      Math.round(
                        props.price.purchasePrice *
                          props.componentQuantity *
                          100,
                      ) / 100
                    ).toFixed(2),
                  )
              : currencyFormatter("", false) + "0.00"}
          </span>
          <span className={classes.priceSpan}>
            {" "}
            {props.price.recurringPrice
              ? parseInt(props.price.recurringPrice.price) === 0 &&
                props.dontShowZero
                ? ""
                : currencyFormatter(
                    (
                      Math.round(
                        props.price.recurringPrice.price *
                          props.componentQuantity *
                          100,
                      ) / 100
                    ).toFixed(2),
                  )
              : currencyFormatter("", false) + "0.00"}
          </span>
        </React.Fragment>
      ) : (
        <React.Fragment>
          {props.providerType === "SALES_CHNL_PROVIDER" ||
          props.publicBrowsing ? (
            props.price ? (
              <>
                {/* Non modifiable quantity component will goes here */}
                <span className={classes.priceSpan}>
                  {!props.price.recurringPrice && props.price.purchasePrice
                    ? parseInt(props.price.purchasePrice) === 0 &&
                      props.dontShowZero
                      ? ""
                      : currencyFormatter(
                          (
                            Math.round(
                              props.price.purchasePrice *
                                (props.componentQuantity * props.quantity) *
                                100,
                            ) / 100
                          ).toFixed(2),
                        )
                    : currencyFormatter("", false) + "0.00"}
                </span>
                <span className={classes.priceSpan}>
                  {props.price.recurringPrice
                    ? parseInt(props.price.recurringPrice.price) === 0 &&
                      props.dontShowZero
                      ? ""
                      : currencyFormatter(
                          (
                            Math.round(
                              props.price.recurringPrice.price *
                                (props.componentQuantity * props.quantity) *
                                100,
                            ) / 100
                          ).toFixed(2),
                        )
                    : currencyFormatter("", false) + "0.00"}
                </span>
              </>
            ) : (
              <span className={classes.priceSpan}>
                {currencyFormatter("", false)}0.00
              </span>
            )
          ) : (
            ""
          )}
        </React.Fragment>
      )}
    </div>
  </div>
);
// Line item end here

// Check for packaged solution price
const isSolutionPriceZeroOrEmpty = (solution) => {
  let finalPrice = 0;
  if (!solution) {
    return true;
  }
  if (solution.price.recurringPrice) {
    finalPrice = solution.price.recurringPrice.price;
  }
  if (!finalPrice) {
    finalPrice = solution.price.purchasePrice;
  }
  if (!finalPrice || 0 === parseInt(finalPrice)) {
    return true;
  }
  return false;
};

// Create packaged solution and return to parent (Cart)
const CartItem = (props) => {
  const t = props.t;
  return (
    <React.Fragment>
      {/* Show packaged solution start */}
      <div
        style={{ justifyContent: "space-between" }}
        className={classes.SolutionCountDiv}
      >
        <div
          className={classes.SolutionCountDiv}
          style={{ backgroundColor: "transparent", padding: 0, border: 0 }}
        >
          <div style={{ width: "2.5rem" }}>
            {/* Remove packaged solution from cart */}
            <Button
              className={classes.removeButton}
              onClick={() => {
                props.removeItem();
              }}
            >
              <span>x</span>
            </Button>
          </div>
          <span>
            <span>
              {/* {props.solution.solution ?
                            <React.Fragment>
                                <input
                                    className={classes.quantityInput}
                                    type="number"
                                    min="1"
                                    step="1"
                                    value={props.solution.quantity}
                                    onChange={(e) => { props.changeQuantity(e.target.value) }}
                                />
                                <span> x </span>
                            </React.Fragment>
                            :
                            null
                        } */}
              <React.Fragment>
                <Input
                  className={classes.quantityInput}
                  type="number"
                  min="1"
                  step="1"
                  value={props.solution.quantity}
                  onChange={(e) => {
                    props.changeQuantity(e.target.value);
                  }}
                  style={{ backgroundColor: "#fff", borderRadius: "5px" }}
                />
                <span> x </span>
              </React.Fragment>
            </span>
            <Link to={`/product/${props.solution.id}`}>
              <span className={classes.SolutionHeaderSpan}>
                {isSolutionPriceZeroOrEmpty(props.solution.solution)
                  ? props.solution.name
                  : props.solution.solution.name}
              </span>
            </Link>
          </span>
        </div>
        {props.solution.selectedPromo && props.solution.selectedPromo.text && (
          <div
            className={classes.SolutionCountDiv}
            style={{ backgroundColor: "transparent", padding: 0, border: 0 }}
          >
            {t("SPECIAL_PRICING")}: {props.solution.selectedPromo.text}
          </div>
        )}
      </div>
      {/* Show packaged solution end */}

      {/* Show sub items of packaged solution */}
      <div className={classes.componentSection}>
        {/* Show Solution plans */}
        {/* {props.solution ?
                    <div>
                        <LineItem dontShowZero={true} {...props.solution} quantity={props.solution.quantity} />
                    </div>
                    : null
                } */}

        {/* new code */}
        {props.solution.associatedItems.map(
          (item, index) =>
            item.customerViewable && (
              <LineItem
                compType={item.type}
                {...item}
                quantity={props.solution.quantity}
                key={index}
                componentQuantity={item.quantity}
                quantityModifiable={item.quantMod}
                // changeComponentQuantity={(value) => { props.changeComponentQuantity(component.name, value, index) }}
                compIndex={index}
                removeComponent={props.removeComponent}
                providerType={props.providerType}
                publicBrowsing={props.publicBrowsing}
                t={t}
              />
            ),
        )}

        {/* Old code */}
        {/* Show all component starts */}
        {/* {props.componentList.length > 0 &&
                    props.componentList.map((component, i) =>
                        props.solution[component.name].length > 0 ?
                            <div key={i}>
                                {props.solution[component.name].map((item, index) =>
                                    <LineItem compType={component.name} {...item} quantity={props.solution.quantity} key={index}
                                        componentQuantity={item.presetQuantity}
                                        quantityModifiable={item.quantMod}
                                        changeComponentQuantity={(value) => { props.changeComponentQuantity(component.name, value, index) }}
                                        compIndex={index}
                                        removeComponent={props.removeComponent}
                                    />

                                )}
                            </div>
                            : null
                    )
                } */}

        {/* Show all component ends */}
        {/* Show Services */}
        {/* {props.solution.services.length > 0 ?
                    <div>
                        <div className={classes.sumSecHeader}>Services</div>
                        {props.solution.services.map((item, index) =>
                            <LineItem key={index}  {...item} quantity={props.solution.quantity} />
                        )}
                    </div> :
                    null
                } */}
      </div>
    </React.Fragment>
  );
};

export default withTranslation("translations")(CartItem);
